import { Component, Input, input } from '@angular/core';
import { ChartConfiguration, ChartData, ChartType } from 'chart.js';
import { NgChartsModule } from 'ng2-charts';

@Component({
    selector: 'app-bar-chart[data]',
    template: `
    <div class="my-4">
      <canvas
        baseChart
        [data]="data()"
        [options]="_config"
        [plugins]="[]"
        [type]="type"
      >
      </canvas>
    </div>
  `,
    styles: [],
    imports: [NgChartsModule]
})
export class BarChartComponent {

  readonly title = input<string>('');

  @Input() set configTitle(title: { text: string, display: boolean, font: {size: number}}) {
    this._config = { ...this._config, plugins: { ...this._config?.plugins } };
  }
  // https://www.chartjs.org/docs/latest/configuration/responsive.html#important-note
  _config: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: true,
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 25,
        },
        min: 0,
        max: 100,
      },
    },
    plugins: {
      title: {
        text: '',
        display: true,
        font: {
          size: 24,
        },
      },
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function(context){
            return (context.raw as number).toFixed(0) + '%';
          }
        }
      }
    },
    indexAxis: 'x',
  };

  readonly data = input<ChartData<'bar'>>({
    labels: [],
    datasets: [],
});

  readonly type: ChartType = 'bar';

  constructor() {}
}
